import { api } from "./axios.config";
import axios from "./axios";
import { getCurrentEventId } from "../Utils/helpers";

const API_URL = api.apiUrl;
const BASE_PATH = "/event/";

export const getAllAssets = () => {
    const eventId = getCurrentEventId();
    return axios.get(`${API_URL}${BASE_PATH}${eventId}/exhibitors/tasks`, {
        params: { type: 2 },
    });
};

export const createAsset = (payload) => {
    const eventId = getCurrentEventId();
    return axios.post(
        `${API_URL}${BASE_PATH}${eventId}/exhibitors/tasks?type=2`,
        payload
    );
};

export const updateAsset = (assetId, payload) => {
    const eventId = getCurrentEventId();
    return axios.put(
        `${API_URL}${BASE_PATH}${eventId}/exhibitors/tasks/${assetId}?type=2`,
        payload
    );
};

export const deleteAsset = (assetId) => {
    const eventId = getCurrentEventId();
    return axios.delete(
        `${API_URL}${BASE_PATH}${eventId}/exhibitors/tasks/${assetId}`
    );
};
export const getAssetById = (assetId) => {
    const eventId = getCurrentEventId();
    return axios.get(`${API_URL}${BASE_PATH}${eventId}/exhibitors/tasks?type=2&task_ids=${assetId}`);
};
